<template>
  <div id="scroll-box" ref="scroll-box" class="scroll-box" @scroll="handleScroll">
    <div ref="scroll-cont" class="scroll-main">
      <slot/>
    </div>
    <div
      v-show="backTop && backToTop"
      class="scroll-icon"
      @click="handleBackTop"
    >
      <i class="el-icon-arrow-up" style="font-weight: 600;"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    offsetTop: {
      type: Number,
      default: 0
    },
    onReachBottom: {
      type: Function,
      default () {
        return null
      }
    },
    stop: {
      type: Boolean,
      default: false
    },
    bottom: {
      type: Number,
      default: 0
    },
    backToTop: {
      type: Boolean,
      default: true
    },
    canLoading: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      loading: true,
      eHeight: 0,
      eScrollTop: 0
    }
  },
  computed: {
    backTop () {
      return this.eScrollTop > 0 && this.eScrollTop > this.eHeight
    }
  },
  watch: {
    eScrollTop (val) {
      if (this.offsetTop && val) {
        let toTop = (val > this.offsetTop)
        this.$emit('onAffix', toTop)
      }
    }
  },
  methods: {
    async handleScroll (e) {
      if (!this.canLoading) return
      const eH = e.target.clientHeight
      const eScrollTop = e.target.scrollTop
      const cH = this.$refs['scroll-cont'].clientHeight
      this.eHeight = eH
      this.eScrollTop = eScrollTop
      if (eH + eScrollTop + this.bottom >= cH && this.loading && !this.stop && eScrollTop) {
        this.loading = false
        try {
          await this.onReachBottom()
        } catch (e) {
          this.$Message.error(e)
        } finally {
          this.loading = true
        }
      }
    },
    handleBackTop () {
      // TODO.动画效果
      this.$emit('onAffix', false)
      this.$refs['scroll-box'].scrollTop = 0
      // const scrollTop = this.$refs['scroll-box'].scrollTop
      // this.$refs['scroll-box'].style.marginTop = `-${scrollTop}px`
      // this.$refs['scroll-box'].scrollTop = 0
      // this.$refs['scroll-box'].style.transition = 'all 1s ease-in-out'
      // this.$refs['scroll-box'].style.marginTop = 0

      // setTimeout(() => {
      //   this.$refs['scroll-box'].style.transition = 'none'
      // }, 1000)
    }
  }
}
</script>
<style lang="scss" scoped>
.scroll-box {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  .scroll-main {
    height: auto;
    // overflow: hidden;
  }
  .scroll-icon {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    bottom: 64px;
    right: 60px;
    z-index: 2;
    border-radius: 50%;
    border: 1px solid #EEEFF1;
    box-shadow: 0px 2px 8px rgba(51, 51, 51, 0.1);
    background: #ffffff;
    transition: all .3s ease;
    cursor: pointer;
  }
}
</style>